import importExport from './import&export.vue'
import moment from 'moment'
export default {
  components: { importExport },
  methods: {
    importProduct() {
      this.$refs['importExport'].importProduct();
    },
    // 导出 --新接口
    onExport() {
      
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
        let columnData = []
        this.columnData.forEach(v => {
          columnData.push({
            columnName: v.label,
            fieldName: v.prop            
          })
        });
        let data = {
          ...this.exportForm,
          exportColumnList: columnData
        }
        this.$q.productModelDetails.bigModelSaleDetailExport({data: data,options: {responseType: 'blob'}}).then((res) => {
          loading.close();
          let fileName = '大型号销量明细'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.XLSX`);
        });
    },
  }
}